export default __webpack_public_path__ + "static/media/map.47a76e1c.jpeg";